module.exports = __webpack_public_path__ + "static/img/video_8.bdcaa08.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/video_8.jpg
// module id = 2v4r
// module chunks = 1